import http from '../../../utils/fetch';
export default {
    page(query) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastplanDetailed/selectPage',
            method: 'post',
            params: query
        });
    },
    showYCList(query) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastplanDetailed/showYCList',
            method: 'post',
            params: query
        });
    },
    showPage(q) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastplanDetailed/showPage',
            method: 'post',
            params: q
        });
    },
    showList(q) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastplanDetailed/showList',
            method: 'post',
            params: q
        });
    },
    // showReport(v) {
    //     return http({
    //         url: '/api/swyl/v1/demo/bscForecastplanDetailed/showReportPage',
    //         method: 'post',
    //         params: v
    //     });
    // },
    selectReport(v) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastplanDetailed/selectReportPage',
            method: 'post',
            params: v
        });
    },
    showAllTarget() {
        return http({
            url: '/api/swyl/v1/demo/bscForecastplanDetailed/showAllTarget',
            method: 'post'
        });
    },
    showModel(v){
        return http.post('/api/swyl/v1/demo/bscForecastplanDetailed/selectModel?productType='+v);
    },

    // showNum() {
    //     return http({
    //         url: '/api/swyl/v1/demo/bscForecastplanDetailed/showNum',
    //         method: 'post'
    //     });
    //     return http.post('/api/swyl/v1/demo/bscForecastplanDetailed/showNum');
    // },
    showLName(){
        return http({
            url: '/api/swyl/v1/demo/bscForecastplanDetailed/selectLeName',
            method: 'post'
        });
    },
    shTG(obj){
        return http.post('/api/swyl/v1/demo/bscForecastplanDetailed/updateStatustrue',obj);
    },
    shBTG(obj){
        return http.post('/api/swyl/v1/demo/bscForecastplanDetailed/updateStatusfalse',obj);
    },
    showBFB(v){
        return http.post('/api/swyl/v1/demo/bscForecastplan/showPercentage?id='+v);
    },
    saveTo(obj) {
        return http.post('/api/swyl/v1/demo/bscForecastplanDetailed/insert',obj);
    },
    subTo(obj) {
        return http.post('/api/swyl/v1/demo/bscForecastplanDetailed/submitTo',obj);
    },
    submitRevise(obj) {
        return http.post('/api/swyl/v1/demo/bscForecastplanDetailed/submitRevise',obj);
    },
    showType(v){
        return http.post('/api/swyl/v1/demo/bscForecastplanDetailed/selectLevelName?procode='+v);
    },
    showPrice(v){
        return http.post('/api/swyl/v1/demo/bscForecastplanDetailed/selectPrice?promodel='+v);
    },
    selectTax(v){
        return http.post('/api/swyl/v1/demo/bscForecastplanDetailed/selectTax?promodel='+v);
    },
    selectPrice(v){
        return http.post('/api/swyl/v1/demo/bscForecastplanDetailed/selectAllPrice?promodel='+v);
    },
    showPercentage(id){
        return http.post('/api/swyl/v1/demo/bscForecastplan/selectById?id='+id);
    },
    showTarget(c){
        return http.post('/api/swyl/v1/demo/bscForecastplanDetailed/showTarget?cuCode='+c);
    },
    selectText(v){
        return http.post('/api/swyl/v1/demo/bscForecastplan/selectText?id='+v);
    },
    toshow(pageId,nextShow){
        return http({
            url: '/api/swyl/v1/demo/bscNoviceGuideDetail/isShowNoviceGuide',
            method: 'post',
            params: {pageId,nextShow}
        });
    },
}